import React, { useState, useEffect } from 'react'

export const FullscreenAction = () => {
    const [isFullscreen, setIsFullscreen] = useState(false);

    useEffect(() => {
        const handleFullscreenChange = () => {
            setIsFullscreen(!!document.fullscreenElement);
        };

        document.addEventListener('fullscreenchange', handleFullscreenChange);
        
        return () => {
            document.removeEventListener('fullscreenchange', handleFullscreenChange);
        };
    }, []);

    const toggleFullscreen = () => {
        if (!document.fullscreenElement) {
            document.documentElement.requestFullscreen().catch((err) => {
                console.error(`Error al intentar activar pantalla completa: ${err.message}`);
            });
        } else {
            if (document.exitFullscreen) {
                document.exitFullscreen();
            }
        }
    };

    return (
        <div className="nxl-h-item d-none d-sm-flex">
            <div className="full-screen-switcher">
                <button 
                    type="button"
                    className="nxl-head-link me-0 bg-transparent border-0" 
                    onClick={toggleFullscreen}
                >
                    {!isFullscreen ? (
                        <i className="feather-maximize maximize"></i>
                    ) : (
                        <i className="feather-minimize minimize"></i>
                    )}
                </button>
            </div>
        </div>
    )
}
